import { useVirtualizer } from "@tanstack/react-virtual";
import type React from "react";
import { useRef } from "react";
import { normalSanatizerBRL } from "src/utils/functions";
import type { MonthlySnapshot } from "../types";

interface RentVsBuyMobileListProps {
  monthlyData: MonthlySnapshot[];
}

export const RentVsBuyMobileList: React.FC<RentVsBuyMobileListProps> = ({
  monthlyData,
}) => {
  const parentRef = useRef<HTMLDivElement>(null);

  const rowVirtualizer = useVirtualizer({
    count: monthlyData.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 260,
    overscan: 5,
  });

  return (
    <div
      ref={parentRef}
      className="md:hidden w-full h-[500px] overflow-auto pr-2"
    >
      <div
        style={{
          height: `${rowVirtualizer.getTotalSize()}px`,
          width: "100%",
          position: "relative",
        }}
      >
        {rowVirtualizer.getVirtualItems().map((virtualItem) => {
          const snapshot = monthlyData[virtualItem.index];

          return (
            <div
              key={virtualItem.key}
              data-index={virtualItem.index}
              ref={rowVirtualizer.measureElement}
              className="absolute top-0 left-0 w-full"
              style={{
                transform: `translateY(${virtualItem.start}px)`,
                paddingBottom: "1rem",
              }}
            >
              <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm h-full">
                <div className="flex justify-between items-center border-b pb-3 mb-3">
                  <span className="font-bold text-gray-800">
                    Mês {snapshot.month}
                  </span>
                </div>

                <div className="space-y-3 text-sm">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-500">Prestação</span>
                    <span className="font-medium">
                      R$ {normalSanatizerBRL(snapshot.installment)}
                    </span>
                  </div>
                  <div className="flex justify-between items-center bg-blue-50/50 p-2 rounded -mx-2 px-2">
                    <span className="text-blue-700">Aluguel</span>
                    <span className="font-medium text-blue-900">
                      R$ {normalSanatizerBRL(snapshot.rent)}
                    </span>
                  </div>
                  <div className="flex justify-between items-center bg-green-50/50 p-2 rounded -mx-2 px-2">
                    <span className="text-green-700">Saldo Devedor</span>
                    <span className="font-medium text-green-900">
                      R$ {normalSanatizerBRL(snapshot.outstandingBalance)}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-500">Aporte Financiando</span>
                    <span className="font-medium">
                      R$ {normalSanatizerBRL(snapshot.investmentFinancing)}
                    </span>
                  </div>
                  <div className="flex justify-between items-center bg-yellow-50/50 p-2 rounded -mx-2 px-2">
                    <span className="text-yellow-700">Aporte Alugando</span>
                    <span className="font-medium text-yellow-900">
                      R$ {normalSanatizerBRL(snapshot.investmentRenting)}
                    </span>
                  </div>
                  <div className="flex justify-between items-center bg-green-50/30 p-2 rounded -mx-2 px-2">
                    <span className="text-green-700">Patrim. Financiando</span>
                    <span className="font-medium text-green-800">
                      R${" "}
                      {normalSanatizerBRL(snapshot.accumulatedWealthFinancing)}
                    </span>
                  </div>
                  <div className="flex justify-between items-center bg-yellow-50/30 p-2 rounded -mx-2 px-2">
                    <span className="text-yellow-700">Patrim. Alugando</span>
                    <span className="font-medium text-yellow-800">
                      R$ {normalSanatizerBRL(snapshot.accumulatedWealthRenting)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
